/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Category_ImprovementInputs */

const vi_whats_new_category_improvement = /** @type {(inputs: Whats_New_Category_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cải tiến`)
};

/**

* @param {Whats_New_Category_ImprovementInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_category_improvement = /** @type {((inputs?: Whats_New_Category_ImprovementInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Category_ImprovementInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_category_improvement(inputs)
});